import React from 'react';
import Button from '@material-ui/core/Button';

class Faq extends React.Component {

    handleRevokeAccess = () => {
        /*fetch('https://www.strava.com/oauth/deauthorize', {
                credentials: 'include',
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
                body: "access_token=" + this.props.app.token
            }
            ).then(function (response) {
                return response.json();
            }).then(json => {
                console.log(json)
            })*/

        localStorage.removeItem('refresh_token')
    }


    /**
     * Render the component
     */
    render() {

        return (
            <div style={{
                fontFamily:'sans-serif',
                marginTop: 60,

            }}>
                <div style={{
                    paddingLeft: '20%',
                    paddingRight: '20%',
                    backgroundColor: '#EEE',
                    color: '#666',
                    lineHeight: '130px',
                    height: 130,
                    fontSize: 26
                }}>
                    Frequently Asked Questions

                </div>
                <div style={{
                    marginTop: 30,
                    paddingLeft: '20%',
                    paddingRight: '20%'
                }}>
                    <span><b>I do not have a Strava account, can i still use Cartorion?</b></span><br /><br />
                    <span>
                        Currently, Cartorion can only use activities available on Strava.<br />
                        Nevertheless, it's pretty easy to create a Strava account and import your data from GPX files or,
                        if you already use an another service to track runs or rides, to synchronize these data using a
                        service like <a style={{ color: '#2196f3', textDecoration: 'none' }} target='_blank' rel="noopener noreferrer" href='https://tapiriik.com/'>Tapiriik</a>.
                        You can find many other importers on <a style={{ color: '#2196f3', textDecoration: 'none' }} target='_blank' rel="noopener noreferrer" href='https://www.strava.com/apps/data-importer'>this page</a>.
                    </span><br /><br /><br />

                    <span><b>What is low and high resolution images?</b></span><br /><br />
                    <span>
                        When you download your image, you can choose between two resolutions :
                        <ul>
                            <li>Low resolution : 432 x 576 pixels (72DPI for a 6 x 8" image)</li>
                            <li>High resolution : 3600 x 4800 pixels (300DPI for a 12 x 16" poster)</li>
                        </ul>

                        Images used for online or web graphics can be at low resolution (72 DPI)
                        and will look fine on a computer screen. But if you try to print those same pictures,
                        they’ll look horribly pixelated. For printing purposes, images should be at least 300 DPI so
                        we advice to choose the high resolution button.<br /><br />
                        Find out more about resolution by using <a style={{ color: '#2196f3', textDecoration: 'none' }} target='_blank' rel="noopener noreferrer" href='https://www.pixelcalculator.com/'>this calculator</a>.
                    </span><br /><br /><br />

                    <span><b>How much does it cost to use Cartorion?</b></span><br /><br />
                    <span>It’s free to create your own digital art on Cartorion. <br />
                        If you would like to download high resolution images, each download costs 5$.<br />
                        If you would like to buy an enhanced matte paper poster, each poster costs 35$. Available size is only 12x16".<br />
                        Currently, we offer free shipping.
                    </span><br /><br /><br />

                    <span><b>Is my payment secure?</b></span><br /><br />
                    <span>We use <a style={{ color: '#2196f3', textDecoration: 'none' }} target='_blank' rel="noopener noreferrer" href='https://stripe.com'>Stripe</a> to
                        handle payments in a secure way. No credit card details are stored on Cartorion.
                    </span><br /><br /><br />

                    <span><b>What will my print look like?</b></span><br /><br />
                    <span>Here are one or two examples (Frames are not included in your orders).<br />
                        <img alt='Example 1' height='450' src='img/real1.jpg' />&nbsp;&nbsp;&nbsp;&nbsp;
                        <img alt='Example 2' height='450' src='img/real2.jpg' /><br />
                        We would be glad to add links to your prints shared on social media. Please send your links to <a style={{ color: '#2196f3', textDecoration: 'none' }}
                            href='mailto:support@cartorion.com'>support@cartorion.com</a> and we'll add them here.
                    </span><br /><br /><br />

                    <span><b>How do I revoke access to my data?</b></span><br /><br />
                    <span>After you log in to your account on <a style={{ color: '#2196f3', textDecoration: 'none' }} target='_blank' rel="noopener noreferrer" href='https://strava.com'>Strava</a>,
                        go to "My Apps" in your "Settings". Then click on "Revoke access" for the Cartorion item.<br />
                        If you only want to revoke persistent login, click the button below : <br /><br />
                        <Button onClick={this.handleRevokeAccess} variant="contained"> Do not remember me</Button>
                    </span><br /><br /><br />

                    <span><b>Something went wrong while using Cartorion!</b></span><br /><br />
                    <span>Just send us an email at <a style={{ color: '#2196f3', textDecoration: 'none' }}
                        href='mailto:support@cartorion.com'>support@cartorion.com</a> and we'll do our best to find a solution.
                    </span><br /><br /><br />
                </div>
            </div>
        )
    }
}

export default Faq;


// WEBPACK FOOTER //
// ./src/components/website/Faq.js